// ** React
import { useContext } from "react";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Custom Components
import Link from "components/layout/Link";
import Paragraph from "components/typography/Paragraph";
import Block from "components/layout/Block";

// ** Utils & Helpers
import generateQueryPath from "utils/generateQueryPath";

// ** Styled Components
import { StyledGridList, StyledGridListPreference } from "./styles";

// ** Context
import DeviceTypeContext from "contexts/deviceTypeContext";

// #####################################################

const Seo = () => {
	const { t } = useTranslation(["filtersAndSelectors"]);

	const { isPhone } = useContext(DeviceTypeContext);

	const locationsSeoContent = useSelector(
		(state) => state.landing.data.locationsSeo || [],
	);

	const preferencesSeoContent = useSelector(
		(state) => state.landing.data.preferencesSeo || [],
	);

	// #####################################################

	return (
		<>
			<Block>
				<Paragraph mb={5} textCenter bold size="1.5rem">
					<Link underline to="/search/locations" color="primary">
						Lokalizacje
					</Link>
				</Paragraph>
				<StyledGridList>
					{locationsSeoContent?.map((city, index) => {
						return (
							<li
								key={`L_` + city.url + `_` + index}
								style={
									isPhone
										? undefined
										: { paddingLeft: "2.5rem" }
								}
							>
								<Paragraph mb={0} size="1.3rem">
									<Link
										color="primary"
										underline
										to={generateQueryPath(
											`/search/${city.url}`,
										)}
									>
										{city.name}
									</Link>
								</Paragraph>
							</li>
						);
					})}
				</StyledGridList>
			</Block>
			<Block mt={10}>
				<Paragraph mb={5} textCenter bold size="1.5rem">
					<Link underline to="/search/preferences" color="primary">
						Preferencje
					</Link>
				</Paragraph>
				<StyledGridListPreference>
					{preferencesSeoContent?.map((preference, index) => (
						<li
							key={`P_` + preference.id + `_` + index}
							style={
								isPhone ? undefined : { paddingLeft: "2.5rem" }
							}
						>
							<Paragraph mb={0} size="1.3rem">
								<Link
									color="primary"
									underline
									to={generateQueryPath(
										`/search/preferences/${preference.url}`,
									)}
								>
									{t(
										`filtersAndSelectors:preferences.${preference.id}`,
									)}
								</Link>
							</Paragraph>
						</li>
					))}
				</StyledGridListPreference>
			</Block>
		</>
	);
};

// #####################################################

export default Seo;

// #####################################################
